module.exports = __webpack_public_path__ + "static/img/superhero_03.da1043c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/events/superhero_03.png
// module id = tOHX
// module chunks = 0